/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Statenb1Inputs */



/**
* | output |
* | --- |
* | "Number of states" |
*
* @param {Br_History_Key_Statenb1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_statenb1 = /** @type {((inputs?: Br_History_Key_Statenb1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Statenb1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Number of states")
	return /** @type {LocalizedString} */ ("Nombre d'état")
});
export { br_history_key_statenb1 as "br_history_key_stateNb" }